import { createRecipe } from './runtime.js';

const publicScrollbarConfig = {"name":"publicScrollbar","className":"scrollbar"}

export const publicScrollbar = /* @__PURE__ */ createRecipe(publicScrollbarConfig)